// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3eZP-","label":"LabeledBox_label__ftgTo"};